export const loadThingsMatterScene = require('bundle-loader?lazy&name=thingsmatter!../modules/ThingsScene');
